import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import { connect } from "react-redux";

// MUI Components
import Grid from "@material-ui/core/Grid";
import { motion, AnimatePresence } from "framer-motion";

// Components
import SnackbarInfo from "./Shared/Snackbar";
import AcquireBar from "./AcquireBar/AcquireBar";
import Header from "./Header/Header";
import LocationSection from "./Locations/LocationSection";
import LocationInfoSection from "./Locations/LocationInfoSection";
import SamplesSection from "./Samples/SamplesSection";
import Results from "./Results/Results";
import StudyInfoSection from "./Results/StudyInfoSection";
import AddNewLocation from "./Locations/AddNewLocation";
import BodyMap from "./Locations/BodyMap";
import { colors } from "../constants/colors";

import { mainAppSectionIds } from "../constants/componentMap";

const useStyles = makeStyles({
  root: {
    flex: "1 1 auto",
    overflow: "hidden",
  },
  main: {
    flex: "1 1 auto",
    overflow: "hidden",
  },
  columnOne: {
    height: "100%",
    backgroundColor: (props) => colors[props.theme].bkg2,
  },
  columnTwo: {
    height: "100%",
    backgroundColor: (props) => colors[props.theme].bkg1,
  },
  columnThree: {
    zIndex: "1",
    height: "100%",
    backgroundColor: (props) => colors[props.theme].bkg2,
  },
  columnFour: {
    zIndex: "1",
    height: "100%",
    backgroundColor: (props) => colors[props.theme].bkg3,
  },
  bCol: {
    display: "flex",
    flexDirection: "column",
    flex: "1 1 auto",
    position: "relative",
    minHeight: 0,
  },
});

const MainApp = (props) => {
  const classes = useStyles(props);
  const sectionElement = (column) => {
    switch (column) {
      case mainAppSectionIds.locationSection:
        return <LocationSection />;
      case mainAppSectionIds.sampleSection:
        return <SamplesSection />;
      case mainAppSectionIds.resultsSection:
        return <Results />;
      case mainAppSectionIds.locationInfoSection:
        return <LocationInfoSection />;
      case mainAppSectionIds.studyInfoSection:
        return <StudyInfoSection />;
      case mainAppSectionIds.addNewLocationSection:
        return <AddNewLocation />;
      case mainAppSectionIds.mapSection:
        return (
          <div className={classes.bCol}>
            <BodyMap />
          </div>
        );
      default:
    }
  };

  return (
    <Grid
      container
      className={classes.root + " noselect"}
      direction="column"
      wrap="nowrap"
    >
      {/* HEADER */}
      <Header />
      {/* APP */}
      <Grid container className={classes.main} wrap="nowrap">
        {/* COLUMN ONE */}
        <React.Fragment>
          <AnimatePresence>
            {props.mainViewSection.orientation === "LEFT" && (
              <motion.div
                className={classes.root}
                initial={{ maxWidth: 0 }}
                animate={{ maxWidth: "40%" }}
                exit={{ maxWidth: 0 }}
              >
                <Grid
                  item
                  container
                  className={classes.columnOne}
                  direction="column"
                >
                  {sectionElement(props.mainViewSection.columnOne)}
                </Grid>
              </motion.div>
            )}
          </AnimatePresence>
        </React.Fragment>

        {/* COLUMN TWO */}
        <React.Fragment>
          <AnimatePresence>
            {(props.mainViewSection.orientation === "LEFT" ||
              props.mainViewSection.orientation === "CENTER") && (
              <motion.div
                className={classes.root}
                initial={{ maxWidth: 0 }}
                animate={{
                  maxWidth:
                    props.mainViewSection.orientation === "CENTER"
                      ? "40%"
                      : "60%",
                }}
                exit={{ maxWidth: 0 }}
              >
                <Grid
                  item
                  container
                  className={classes.columnTwo}
                  direction="column"
                >
                  {sectionElement(props.mainViewSection.columnTwo)}
                </Grid>
              </motion.div>
            )}
          </AnimatePresence>
        </React.Fragment>

        {/* COLUMN THREE */}
        <React.Fragment>
          <AnimatePresence>
            {(props.mainViewSection.orientation === "CENTER" ||
              props.mainViewSection.orientation === "RIGHT") && (
              <motion.div
                className={classes.root}
                initial={{ maxWidth: 0 }}
                animate={{
                  maxWidth:
                    props.mainViewSection.orientation === "CENTER"
                      ? "60%"
                      : "40%",
                }}
                exit={{ maxWidth: 0 }}
              >
                <Grid
                  item
                  container
                  className={classes.columnThree}
                  direction="column"
                >
                  {sectionElement(props.mainViewSection.columnThree)}
                </Grid>
              </motion.div>
            )}
          </AnimatePresence>
        </React.Fragment>

        {/* COLUMN FOUR */}
        <React.Fragment>
          <AnimatePresence>
            {props.mainViewSection.orientation === "RIGHT" && (
              <motion.div
                className={classes.root}
                initial={{ maxWidth: 0 }}
                animate={{
                  maxWidth: "60%",
                }}
                exit={{ maxWidth: 0 }}
              >
                <Grid
                  item
                  container
                  className={classes.columnFour}
                  direction="column"
                >
                  {sectionElement(props.mainViewSection.columnFour)}
                </Grid>
              </motion.div>
            )}
          </AnimatePresence>
        </React.Fragment>
      </Grid>

      <AcquireBar />
      <SnackbarInfo />
    </Grid>
  );
};

const mapStateToProps = (state) => {
  return {
    mainViewSection: state.view.mainViewSection,
    theme: state.utility.theme,
  };
};

export default connect(mapStateToProps)(MainApp);
